export const PATRONES_ROTACION = [
  {
    id: 'cuarto_turno',
    label: 'Cuarto turno',
    descripcion: 'Largo - Noche - Libre - Libre',
    secuencia: ['L', 'N', '_', '_'],
  },
  {
    id: 'lunes_viernes_diurno',
    label: 'Lunes a viernes diurno',
    descripcion: '8:00 a 17:00, fin de semana libre',
    secuencia: ['D', 'D', 'D', 'D', 'D', '_', '_'],
  },
  {
    id: 'fin_de_semana',
    label: 'Fin de semana',
    descripcion: 'Sábado y domingo, semana libre',
    secuencia: ['_', '_', '_', '_', '_', 'L', 'L'],
  },
  {
    id: 'siete_por_siete',
    label: '7 x 7',
    descripcion: 'Una semana de turnos, una libre',
    secuencia: ['L', 'L', 'L', 'L', 'L', 'L', 'L', '_', '_', '_', '_', '_', '_', '_'],
  },
  {
    id: 'personalizado',
    label: 'Personalizado',
    descripcion: 'Configuración manual día a día',
    secuencia: null,
  },
];

export const SERVICIOS_CLINICOS = [
  { id: 'uci',         label: 'UCI',          descripcion: 'Unidad de Cuidados Intensivos' },
  { id: 'medicina',    label: 'Medicina',      descripcion: 'Medicina interna' },
  { id: 'cirugia',     label: 'Cirugía' },
  { id: 'urgencia',    label: 'Urgencia' },
  { id: 'pabellon',    label: 'Pabellón' },
  { id: 'pediatria',   label: 'Pediatría' },
  { id: 'maternidad',  label: 'Maternidad',   descripcion: 'Obstetricia y ginecología' },
  { id: 'neonatologia',label: 'Neonatología' },
  { id: 'psiquiatria', label: 'Psiquiatría' },
  { id: 'ambulatorio', label: 'Ambulatorio',  descripcion: 'Atención abierta o consultorio' },
  { id: 'otro',        label: 'Otro' },
];

// El id del servicio ('uci') NO es su nombre visible ('UCI'). CalendarioConfig
// guarda el id, y hasta ahora siete superficies lo pintaban crudo: el usuario
// leía "uci", "cirugia", "pediatria" — sin mayúsculas y sin acentos. Fuente
// única del nombre para TODAS las superficies (norma de coherencia: un rename
// aplica en todas). El override de un día gana sobre la rotación de base, y
// `servicio_otro` (lo que escribió el usuario) gana sobre el catálogo.
// Cada fuente se resuelve ENTERA antes de caer a la siguiente. Mezclar los
// campos (servicio_otro de una con servicio de la otra) parece equivalente y no
// lo es: el override de un día guarda `servicio_otro: null` siempre
// (DetalleDiaSheet), así que un `servicio_otro` heredado de la rotación taparía
// para siempre el servicio que el usuario eligió para ESE día.
function servicioDe(fuente) {
  const otro = fuente?.servicio_otro;
  if (otro && String(otro).trim()) return String(otro).trim();
  const id = fuente?.servicio;
  if (!id) return '';
  // Un id fuera de catálogo (rotación vieja) se devuelve tal cual: mostrar algo
  // imperfecto es mejor que dejar el contexto en blanco.
  return SERVICIOS_CLINICOS.find((s) => s.id === id)?.label || id;
}

export function nombreServicio(rotacion, override = null) {
  return servicioDe(override) || servicioDe(rotacion);
}
